import { render, staticRenderFns } from "./CoinSelectButton.vue?vue&type=template&id=4714a264&scoped=true&"
import script from "./CoinSelectButton.vue?vue&type=script&lang=js&"
export * from "./CoinSelectButton.vue?vue&type=script&lang=js&"
import style0 from "./CoinSelectButton.vue?vue&type=style&index=0&id=4714a264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4714a264",
  null
  
)

export default component.exports